import React from "react";
import {useSelector} from "react-redux";

import {
    ROUTES_ORGANIZATIONS_LIST,
    ROUTES_HOME,
} from "../../utils/Constants.js";
import {memberIsAdmin} from "../../utils/Roles.js";
import {Link, useLocation} from "react-router-dom";

import {Box, Typography} from "@mui/material";
import {
    Home as HomeIcon,
    Store as StoreIcon,
} from "@mui/icons-material";

import {isEmpty} from "weed-js";

import {IntegrationsButton} from "./IntegrationButtons.js";

export const NavOptions = ({setMainMenuAccordionExpanded}) => {
    const location = useLocation();
    const loggedInUser = useSelector(state => state.userReducer.loggedInUser.user);
    const profile = useSelector(state => state.userReducer.loggedInUser.profile);
    const organizationUsers = useSelector(state => state.userReducer.loggedInUser.organizationUsers);
    const selectedOrganization = useSelector(state => state.organizationReducer.selectedOrganization);
    const userIsAdmin = memberIsAdmin(loggedInUser, organizationUsers, selectedOrganization);

    return <>
        <Box>
            <Link to={ROUTES_HOME} onClick={() => setMainMenuAccordionExpanded(false)} className={"navlink menu-item"} id="go-home">
                <HomeIcon/>
                <Typography>Home</Typography>
            </Link>
        </Box>
        {isEmpty(profile) || isEmpty(loggedInUser) ? "" : <Box>
            <Link to={ROUTES_ORGANIZATIONS_LIST}
                onClick={() => setMainMenuAccordionExpanded(false)}
                className={"navlink menu-item" + (ROUTES_ORGANIZATIONS_LIST === location.pathname ? " selected" : "")}
                id="go-organizations">
                <StoreIcon/>
                <Typography>Organizations</Typography>
            </Link>
        </Box>}
        <IntegrationsButton 
            loggedInUser={loggedInUser} 
            selectedOrganization={selectedOrganization}
            profile={profile}
            userIsAdmin={userIsAdmin}
            setMainMenuAccordionExpanded={setMainMenuAccordionExpanded}
        />
    </>;
};
